import { GetAuthUrlInteractor } from '../../auth/domain/interactors/get-auth-url.interactor';

export class GetZohoAuthUrlInteractor implements GetAuthUrlInteractor {
  constructor(
    private readonly clientId: string,
    private readonly redirectUri: string,
    private readonly scopes: string,
  ) {}

  public execute(state: string, _pkceChallenge: string, forceConsent: boolean): string {
    // Client-based application: implicit flow returns the access_token directly in the URL fragment.
    // No client_secret, no refresh_token. Token expires in ~1h; the app re-auths silently when needed.
    const params = [
      `client_id=${this.clientId}`,
      `redirect_uri=${encodeURIComponent(this.redirectUri)}`,
      `response_type=token`,
      `scope=${encodeURIComponent(this.scopes)}`,
      `state=${state}`,
      forceConsent ? `prompt=consent` : undefined,
    ]
      .filter((param) => !!param)
      .join('&');

    return `https://accounts.zoho.com/oauth/v2/auth?${params}`;
  }
}
